(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.vrInit)return;
    root.dataset.vrInit='1';
    var grid=root.querySelector('.vr-grid');
    var cards=[].slice.call(grid.children);
    if(!cards.length)return;
    var prev=root.querySelector('.vr-prev'),next=root.querySelector('.vr-next'),dots=root.querySelector('.vr-dots');
    var page=0;
    function per(){return window.matchMedia('(max-width:749px)').matches?1:(window.matchMedia('(max-width:989px)').matches?2:3);}
    function pages(){return Math.max(1,Math.ceil(cards.length/per()));}
    function render(){
      var p=per(),n=pages();
      if(page>=n)page=page%n;
      if(page<0)page=(page%n+n)%n;
      cards.forEach(function(c,i){c.style.display=(i>=page*p&&i<(page+1)*p)?'':'none';});
      if(dots){
        dots.innerHTML='';
        for(var i=0;i<n;i++){(function(i){
          var d=document.createElement('button');
          d.type='button';
          d.className='vr-dot'+(i===page?' on':'');
          d.setAttribute('aria-label','Reviews page '+(i+1));
          d.addEventListener('click',function(){page=i;render();});
          dots.appendChild(d);
        })(i);}
      }
    }
    if(prev)prev.addEventListener('click',function(){var n=pages();page=(page-1+n)%n;render();});
    if(next)next.addEventListener('click',function(){var n=pages();page=(page+1)%n;render();});
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(render,150);});
    render();
  }
  function boot(){document.querySelectorAll('[data-vr-pager]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('[data-vr-pager]');if(r){delete r.dataset.vrInit;init(r);}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roomed-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  var GAP=18;
  function visibleCount(){
    if(window.matchMedia('(max-width:749px)').matches)return 1.15;
    if(window.matchMedia('(max-width:989px)').matches)return 2;
    return 3;
  }
  function init(root){
    if(!root||root.dataset.rrvInit)return;
    root.dataset.rrvInit='1';
    var track=root.querySelector('.rrv__track');
    if(!track)return;
    var cards=[].slice.call(track.children);
    var max=parseInt(root.getAttribute('data-max'),10)||7;
    cards.slice(max).forEach(function(c){track.removeChild(c);});
    cards=[].slice.call(track.children);
    if(!cards.length)return;
    var speed=parseFloat(root.getAttribute('data-speed'))||40;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce){
      cards.forEach(function(c){var cl=c.cloneNode(true);cl.setAttribute('aria-hidden','true');track.appendChild(cl);});
    }
    var setWidth=0;
    function layout(){
      var vis=visibleCount();
      var cw=(root.clientWidth-GAP*(vis-1))/vis;
      [].slice.call(track.children).forEach(function(c){c.style.width=cw+'px';c.style.flex='0 0 '+cw+'px';});
      setWidth=(cw+GAP)*cards.length;
    }
    layout();
    if(reduce){root.style.overflowX='auto';root.style.webkitOverflowScrolling='touch';return;}
    var pos=0,last=null,paused=false;
    root.addEventListener('mouseenter',function(){paused=true;});
    root.addEventListener('mouseleave',function(){paused=false;});
    root.addEventListener('touchstart',function(){paused=true;},{passive:true});
    root.addEventListener('touchend',function(){paused=false;},{passive:true});
    function frame(ts){
      if(last===null)last=ts;
      var dt=(ts-last)/1000;last=ts;
      if(!paused){
        pos-=speed*dt;
        if(-pos>=setWidth)pos+=setWidth;
        track.style.transform='translateX('+pos+'px)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    var rt;
    window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){pos=0;track.style.transform='translateX(0px)';layout();},150);});
  }
  function boot(){document.querySelectorAll('[data-roomed-reviews]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('[data-roomed-reviews]');if(r){delete r.dataset.rrvInit;init(r);}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roomed-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  function checkScroll() {
    if (window.scrollY > 5) {
      document.body.classList.add('r-scrolled');
    } else {
      document.body.classList.remove('r-scrolled');
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();
})();

  } catch(e) { console.error(e); }
})();
})();
